export enum FileStatus {
    AVAILABLE = "available",
    PENDING = "pending",
    NOT_AVAILABLE = "not-available",
    EXPIRED = "expired",
    REQUESTED = "requested",
}